// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"e2b053cd","84":"2c7beef7","864":"91c6c253"}[chunkId] + ".chunk.css";
};